// Letzte Rettung bei einem Absturz beim Rendern (QA Runde 2 N20): deutscher Text statt weisser Seite oder
// englischer Bibliotheksmeldung. Neu laden reicht fast immer; Daten liegen auf dem Server.
import { Component, type ErrorInfo, type ReactNode } from 'react';

export class Fehlergrenze extends Component<{ children: ReactNode }, { fehler: boolean }> {
  override state = { fehler: false };

  static getDerivedStateFromError(): { fehler: boolean } {
    return { fehler: true };
  }

  override componentDidCatch(fehler: unknown, info: ErrorInfo): void {
    console.error('Absturz beim Anzeigen', fehler, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.fehler) return this.props.children;
    return (
      <main style={{ padding: '48px 20px', maxWidth: 480, margin: '0 auto', fontFamily: 'inherit' }}>
        <h1 style={{ fontSize: 24, lineHeight: '30px', fontWeight: 800, margin: '0 0 12px' }}>Da ist etwas schiefgegangen</h1>
        <p style={{ margin: '0 0 24px', color: 'var(--nb-color-ink-muted)' }}>
          Nebenbei konnte diese Seite nicht anzeigen. Lade sie neu, deine Daten sind sicher.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            minHeight: 56,
            padding: '0 24px',
            border: 'none',
            borderRadius: 'var(--nb-radius-pill)',
            background: 'var(--nb-color-primary)',
            color: 'var(--nb-color-on-primary)',
            font: 'inherit',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Neu laden
        </button>
      </main>
    );
  }
}
